var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMobileMenuChevron = function SvgMobileMenuChevron(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.862 5.64333C6.73702 5.76835 6.66681 5.93789 6.66681 6.11467C6.66681 6.29144 6.73702 6.46098 6.862 6.586L8.276 8L6.862 9.414C6.73691 9.539 6.66659 9.70858 6.66653 9.88543C6.6665 9.973 6.68372 10.0597 6.7172 10.1406C6.75068 10.2215 6.79977 10.2951 6.86167 10.357C6.92356 10.4189 6.99705 10.4681 7.07794 10.5016C7.15883 10.5352 7.24553 10.5524 7.3331 10.5525C7.50994 10.5525 7.67957 10.4823 7.80467 10.3573L9.69067 8.47133C9.81565 8.34632 9.88586 8.17678 9.88586 8C9.88586 7.82322 9.81565 7.65368 9.69067 7.52867L7.80467 5.64333C7.67965 5.51835 7.51011 5.44814 7.33333 5.44814C7.15656 5.44814 6.98702 5.51835 6.862 5.64333Z",
    fill: "#999999"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMobileMenuChevron);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mobile-menu-chevron.706de6d262dea55640489159daf19785.svg";